import classnames from 'classnames';
import React from 'react';

import { CarretDownIcon, CarretUpIcon } from '../icons/SvgIcons';

const PANEL_HEIGHT = 80;

type ExpandablePanelProps = {
  title: string | React.ReactNode;
  titleClassName?: string;
  count?: number;
  children: React.ReactNode;
};
const ExpandablePanel: React.FC<ExpandablePanelProps> = React.memo((props) => {
  const { title, titleClassName, count, children } = props;
  const [isExpanded, setIsExpanded] = React.useState(false);
  return (
    <React.Fragment>
      <div
        className="cursor-pointer flex w-full justify-between items-center"
        style={{ height: `${PANEL_HEIGHT}px` }}
        onClick={() => setIsExpanded(!isExpanded)}
      >
        <h3 className={titleClassName ?? 'font-semibold'}>{title}</h3>
        <button aria-expanded={isExpanded} className="text-xl inline-flex items-center font-medium gap-2 bg-purple rounded-full px-4 py-2">
          {isExpanded && <CarretUpIcon />}
          {!isExpanded && <CarretDownIcon />}
          {count != null && count}
        </button>
      </div>
      <div
        aria-hidden={!isExpanded}
        className={classnames('transitions-all duration-300 origin-top overflow-hidden', {
          'opacity-0 scale-y-[50%] h-[0]': !isExpanded,
          'opacity-100 scale-y-[100%] h-auto': isExpanded,
        })}
      >
        {children}
      </div>
    </React.Fragment>
  );
});
ExpandablePanel.displayName = 'ExpandablePanel';
export default ExpandablePanel;
